import Vue from 'vue';
import { mapGetters } from 'vuex';

import { SourceTypeEnum } from '@/bundles/App/enums';
import { ITextValue } from '@/types/common';
import { StoreModulesNamesEnum } from '@/store/StoreModulesNamesEnum';
import { Nullable } from '@/utils/types';

interface ICustomFieldMixin<TField extends string> {
  customFieldItems: readonly ITextValue<TField>[];
}

/**
 * Builds the mixin that drives BaseTable's custom field column for one record type.
 * Every list rendering `source` rows gets the member's saved column, the options to
 * pick from, and the source the choice is persisted against.
 */
export const createCustomFieldMixin = <TField extends string>(
  source: SourceTypeEnum,
  getCustomFieldItems: () => ITextValue<TField>[]
) => Vue.extend({
  name: 'CustomFieldMixin',

  data: (): ICustomFieldMixin<TField> => ({
    customFieldItems: Object.freeze(getCustomFieldItems()),
  }),

  computed: {
    ...mapGetters(StoreModulesNamesEnum.Settings, {
      getCustomFieldByEntity: 'getCustomFieldByEntity',
    }),
    customFieldSource (): SourceTypeEnum {
      return source;
    },
    customField (): Nullable<TField> {
      return this.getCustomFieldByEntity(source);
    },
  },

});
